export const LESSON_PLAN_LABELS = Object.freeze({
	PROGRESSIVE: 'Progressive Lesson Plan',
	PROGRESSIVE_PLURAL: 'Progressive Lesson Plans',
	LEGACY_STUDIO: 'Studio Lesson Plan'
});

export const LESSON_PLAN_CATEGORY_NAMES = [
	LESSON_PLAN_LABELS.PROGRESSIVE,
	LESSON_PLAN_LABELS.LEGACY_STUDIO
];

export const getLessonPlanDisplayName = name =>
	name === LESSON_PLAN_LABELS.LEGACY_STUDIO ? LESSON_PLAN_LABELS.PROGRESSIVE : name;
